import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {ExportQuotas as ExportQuotasMutation} from 'nutshell-graphql-types';

import EXPORT_QUOTAS from '../mutations/export-quotas.graphql';

export const useExportQuotas = (): {
    exportQuotas: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [exportQuotas, {loading, error}] = useMutation<ExportQuotasMutation>(EXPORT_QUOTAS, {});

    return {
        exportQuotas: () => exportQuotas(),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
